import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { landingRoute } from '~/utils/constants/routes';
import packageJson from '../../../../../package.json';

const Footer: React.FC = () => {
  //#region Declare Hook
  const { t } = useTranslation();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <footer className='bg-lumi-dark-300 border-t border-white/10'>
      <div className='max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8 mb-12'>
          {/* Brand */}
          <div className='md:col-span-1'>
            <Link to={landingRoute.home} className='flex items-center gap-2 mb-4'>
              <img src={require('~/assets/images/logo.svg').default} alt='Lumi' className='w-8 h-8 rounded-lg' />
              <span className='text-white font-bold text-xl'>Lumi</span>
            </Link>
            <p className='text-white/50 text-sm leading-relaxed'>{t('footer.tagline')}</p>
            <p className='text-white/30 text-xs mt-1'>v{packageJson.version}</p>
          </div>

          {/* Product */}
          <div>
            <h4 className='text-white font-semibold text-sm mb-4'>{t('footer.product')}</h4>
            <ul className='space-y-3'>
              <li>
                <Link to={landingRoute.features} className='text-white/50 hover:text-white text-sm transition-colors duration-200'>
                  {t('footer.features')}
                </Link>
              </li>
              <li>
                <Link to={landingRoute.pricing} className='text-white/50 hover:text-white text-sm transition-colors duration-200'>
                  {t('footer.pricing')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className='text-white font-semibold text-sm mb-4'>{t('footer.company')}</h4>
            <ul className='space-y-3'>
              <li>
                <Link to={landingRoute.about} className='text-white/50 hover:text-white text-sm transition-colors duration-200'>
                  {t('footer.about')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className='text-white font-semibold text-sm mb-4'>{t('footer.legal')}</h4>
            <ul className='space-y-3'>
              <li>
                <Link to={landingRoute.privacyPolicy} className='text-white/50 hover:text-white text-sm transition-colors duration-200'>
                  {t('footer.privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link to={landingRoute.termsOfService} className='text-white/50 hover:text-white text-sm transition-colors duration-200'>
                  {t('footer.termsOfService')}
                </Link>
              </li>
              <li>
                <Link to={landingRoute.cookiePolicy} className='text-white/50 hover:text-white text-sm transition-colors duration-200'>
                  {t('footer.cookiePolicy')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className='pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4'>
          <p className='text-white/40 text-sm'>
            © {new Date().getFullYear()} Lumi. {t('footer.rights')}
          </p>
          <p className='text-white/40 text-sm'>{t('footer.madeWith')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
